import { defineMaterial, type MaterialComponentProps } from '@h5/schema';
import { ImagePropsSchema, type ImageProps } from './schema';

export { ImagePropsSchema, type ImageProps };

/** 图片物料：地址一律经 ctx.assets.url 处理，按图层实际宽度请求缩放图。 */
function ImageView({ props, ctx }: MaterialComponentProps<ImageProps>) {
  const base: React.CSSProperties = {
    width: '100%',
    height: '100%',
    display: 'block',
    borderRadius: props.radius,
    overflow: 'hidden',
    boxSizing: 'border-box',
  };
  if (!props.src) {
    return (
      <div style={{ ...base, background: '#f0f0f0', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', fontSize: 12 }}>
        请选择图片
      </div>
    );
  }
  const width = Math.ceil(ctx.layer.rect.w * ctx.scale * 2); // 2x 应对高清屏
  return (
    <img
      src={ctx.assets.url(props.src, { width })}
      alt=""
      draggable={false}
      style={{ ...base, objectFit: props.fit, pointerEvents: 'none' }}
    />
  );
}

export const imageMaterial = defineMaterial<ImageProps>({
  id: 'image',
  version: 1,
  name: '图片',
  category: 'basic',
  icon: '🖼',
  defaultSize: { w: 200, h: 150 },
  defaultProps: ImagePropsSchema.parse({}),
  propsSchema: ImagePropsSchema,
  capabilities: { keepRatio: true },
  component: ImageView,
});
